import type { SdkKeyTier } from '@ekhodealer/ekho-common';

// Minimal, dependency-free publishable-key parsing for the loader bundle.
//
// The canonical parser lives in @ekhodealer/ekho-common (`parsePublishableKey`),
// but importing it as a *value* drags the entire types barrel — including zod —
// into the loader, blowing the bundle past 15kB. The loader must stay tiny, so
// it duplicates only the prefix logic here. `SdkKeyTier` is still imported as a
// type (erased at build) so the two stay structurally in sync.
const LIVE_PREFIX = 'ek_live_';
const TEST_PREFIX = 'ek_test_';

export interface ParsedKey {
  tier: SdkKeyTier;
  svpId: string;
}

export function parseKey(key: string | null): ParsedKey | null {
  if (!key) return null;
  if (key.startsWith(LIVE_PREFIX)) {
    const svpId = key.slice(LIVE_PREFIX.length);
    return svpId ? { tier: 'live', svpId } : null;
  }
  if (key.startsWith(TEST_PREFIX)) {
    const svpId = key.slice(TEST_PREFIX.length);
    return svpId ? { tier: 'test', svpId } : null;
  }
  return null;
}
